import React, { useState, useEffect } from "react";
import { Row, Col, Card, Form, Input, Select, Spin, PageHeader, DatePicker, Button, Modal, Result, Alert, InputNumber } from "antd";
import { useSelector } from "react-redux";
import { useBillFeesMutation, useBillSaarGetCategoriesMutation, useBillSaarGetCouvertureMutation, useBillSaarGetPacksPrivilegeMutation, useBillSaarGetVehiculesMutation, useBillSaarPayMutation, useBillSaarSimulationMutation } from "../service/bill-api";
import SuccessDialog from "../../../components/Dialog/success";
import TransactionResume from "../../../components/Dialog/transaction-resume";

const { Option } = Select;

export function BillSaarPage() {
  const { currentAgent } = useSelector((state) => state.auth);
  const [billSaarGetCategories] = useBillSaarGetCategoriesMutation();
  const [billSaarGetCouverture] = useBillSaarGetCouvertureMutation();
  const [billSaarGetVehicules] = useBillSaarGetVehiculesMutation();
  const [billSaarSimulation] = useBillSaarSimulationMutation();
  const [billSaarGetPacksPrivilege] = useBillSaarGetPacksPrivilegeMutation();
  const [categories, setCategories] = useState([]);
  const [categorie, setCategorie] = useState();
  const [couvertures, setCouvertures] = useState([]);
  const [vehicules, setVehicules] = useState([]);
  const [packsPrivileges, setPacksPrivileges] = useState([]);
  const [simulatorRequest, setSimulatorRequest] = useState();
  const [simulatorResult, setSimulatorResult] = useState();
  const [payResult, setPayResult] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [effectiveDate, setEffectiveDate] = useState();
  const [dateOfCirculation, setDateOfCirculation] = useState();
  const [billSAARPay] = useBillSaarPayMutation();
  const [billFees] = useBillFeesMutation();
  const [show, setShow] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isCategorieLoading, setIsCategorieLoading] = useState(false);
  const [error, setError] = useState();
  const [fees, setFees] = useState();
  const [formdata, setFormData] = useState();
  const [form] = Form.useForm();
  const [activeTab, setActiveTab] = useState('tarification');

  const handleGetCategories = async () => {
    const data = {
      country: currentAgent.country,
      token: currentAgent.access_token,
      agent_msisdn: currentAgent.agent_msisdn,
      pincode: "",
    }
    billSaarGetCategories(data)
      .unwrap()
      .then((res) => {
        setCategories(res.data);
      })
      .catch((error) => {
        setIsCategorieLoading(false)
        setIsLoading(false);
        setError(error.data.error);
      });
  };

  const handleChangeCategorie = async (value) => {
    try {
      const data = {
        country: currentAgent.country,
        token: currentAgent.access_token,
        agent_msisdn: currentAgent.agent_msisdn,
        code_categorie: value,
        pincode: "",
      };
      setIsLoading(true);

      const [couvertureRes, vehiculesRes, packsPrivilegesRes] = await Promise.all([
        billSaarGetCouverture(data).unwrap(),
        billSaarGetVehicules(data).unwrap(),
        billSaarGetPacksPrivilege(data).unwrap()
      ]);
      setCategorie(value);
      setCouvertures(couvertureRes.data);
      setVehicules(vehiculesRes.data);
      setPacksPrivileges(packsPrivilegesRes.data);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      setError(err.data?.error);
    }
  };

  const handleSimulation = async (values) => {
    setIsLoading(true);
    const data = {
      ...values,
      country: currentAgent.country,
      token: currentAgent.access_token,
      agent_msisdn: currentAgent.agent_msisdn,
      category: categorie,
      pincode: ""
    }
    setSimulatorRequest(data);
    billSaarSimulation(data)
      .unwrap()
      .then((res) => {
        setIsLoading(false);
        setSimulatorResult(res.data);
        setActiveTab('validation');
        setError();
      })
      .catch((error) => {
        setIsLoading(false);
        setError(error.data.error);
      });
  };

  const handleFees = async (value) => {
    setFormData(value);
    setIsLoading(true);
    const data = {
      country: currentAgent.country,
      montant: simulatorResult?.total_amount,
      operation: "COLLECTE",
      receiver: "22220",
      token: currentAgent.access_token,
    };
    setFormData(value);
    await billFees(data).unwrap()
      .then((res) => {
        setIsLoading(false);
        setFees(res);
        setShow(true);
      })
      .catch((error) => {
        setIsLoading(false);
        setError(error.data.error);
      });
  };

  useEffect(() => { handleGetCategories() }, []);


  const handlePay = async (pin) => {
    setIsLoading(true);
    const data = {
      "pincode": pin,
      "receiver_msisdn": formdata.cellular,
      "token": currentAgent.access_token,
      "country": currentAgent.country,
      "amount": simulatorResult?.total_amount,
      "civil_liability": 51078,
      "effective_date": effectiveDate,
      "duration": simulatorRequest.duration,
      "periodicity": simulatorRequest.periodicity,
      "category": categorie,
      "couverture": simulatorRequest.couverture,
      "legal_status": formdata.legal_status,
      "pack_privileges": simulatorRequest.pack_privileges,
      "capital": simulatorRequest.capital ?? "1",
      "accessory_amount": simulatorRequest.accessory_amount,
      "first_name": formdata.first_name,
      "last_name": formdata.last_name,
      "cellular": formdata.cellular,
      "email": formdata.email,
      "profession": formdata.profession,
      "address": formdata.address,
      "vehicule": {
        "date_of_circulation": dateOfCirculation,
        "registration": formdata.registration,
        "genre": simulatorRequest.vehicule,
        "model": formdata.model,
        "chassis": formdata.chassis,
        "brand": formdata.brand,
        "energy": simulatorRequest.energy,
        "seats": simulatorRequest.seats,
        "cylinders": simulatorRequest.cylinders,
        "purchase_price": simulatorRequest.purchase_price,
        "current_price": simulatorRequest.purchase_price,
        "tax_power": simulatorRequest.tax_power,
        "usage": formdata.usage
      }
    };
    billSAARPay(data)
      .unwrap()
      .then((res) => {
        setIsModalOpen(true);
        setIsLoading(false);
        setPayResult(res)
        setShow(false)
        form.resetFields();
      })
      .catch((error) => {
        setShow(false)
        setIsLoading(false);
        setError(JSON.stringify(error.data.error));
      });
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };


  return (
    <div className="default-page saar-page">
      <Spin tip="Chargement..." spinning={isLoading}>
        <TransactionResume
          title="PAIEMENT SAAR ASSURANCE"
          message={"Vous allez effectuer un payement SAAR ASSURANCE d'un montant de " + fees?.amount + " F CFA"}
          fees={fees?.fees}
          isLoading={isLoading}
          status={show}
          handleCancel={() => setShow(false)}
          handlePay={handlePay} />

        <Modal
          centered
          footer={null}
          closable={false}
          open={isModalOpen} onOk={handleOk}
          onCancel={handleCancel}
          className="success-dialog"
        >
          <div style={{ padding: "0px 0px", textAlign: "center" }}>
            <Result status="success" title="Paiement effectuée avec succès" />
            <div>
              <h4>Télécharger l'attestation</h4>
              <a href={`${payResult?.attestation_link}`}>{payResult?.attestation_link}</a><br />
              <a href={`${payResult?.card_brune_link}`}>{payResult?.card_brune_link}</a>
            </div>
            <br />
            <Button
              style={{ margin: "auto" }}
              className="btn btn-primary"
              onClick={() => handleCancel()}>
              Fermer
            </Button>
          </div>
        </Modal>


        <PageHeader title="SAAR ASSURANCE" />

        <Row gutter={16}>
          <Col lg={24} xs={24}>
            <Card>
              <h3>Nouvelle attestation</h3>
              <h1>Estimation du Devis/Cotation</h1>
              <div className="tabs">
                <div
                  className={`tab tab-tarification ${activeTab === 'tarification' ? 'active' : ''}`}
                  onClick={() => setActiveTab('tarification')}
                >
                  <h3>1. Tarification</h3>
                </div>
                <div
                  className={`tab tab-validation ${activeTab === 'validation' ? 'active' : ''}`}
                // onClick={() => setActiveTab('validation')}
                >
                  <h3>2. Validation</h3>
                </div>
              </div>

              <div className="tab-content">
                {activeTab === 'tarification' && (
                  <div className="tab-content-tarification">
                    <Form
                      name="basic"
                      form={form}
                      layout="vertical"
                      initialValues={{
                        purchase_price: 0,
                        current_price: 0,
                        category: 1,
                        duration: 1
                      }}
                      onFinish={handleSimulation}>
                      <Row gutter={24}>
                        <Col span={8}>
                          <Form.Item
                            label="Categories"
                            name="code_categorie"
                            rules={[{ required: true, message: "Champs requis" }]} >
                            <Select onChange={(value) => handleChangeCategorie(value)}>
                              {categories?.map((item) => (<Option value={item.code}>{item.libelle}</Option>))}
                            </Select>
                          </Form.Item>

                          <Row gutter={24}>
                            <Col span={12}>
                              <Form.Item
                                label="Valeur neuve (optionnel)"
                                name="purchase_price">
                                <InputNumber className="form-control" min={0} defaultValue={0} style={{ width: '-webkit-fill-available' }} />
                              </Form.Item>
                            </Col>

                            <Col span={12}>
                              <Form.Item
                                label="Valeur vénale (optionnel)"
                                name="current_price">
                                <InputNumber className="form-control" min={0} defaultValue={0} style={{ width: '-webkit-fill-available' }} />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Form.Item
                            label="Type d'énergie"
                            name="energy"
                            rules={[{ required: true, message: "Champs requis" }]}>
                            <Select>
                              <Option value="ESSENCE">ESSENCE</Option>
                              <Option value="DIESEL">DIESEL</Option>
                            </Select>
                          </Form.Item>

                          <Row gutter={24}>
                            <Col span={12}>
                              <Form.Item label="Nombre de places" name="seats"
                                rules={[{ required: true, message: "Champs requis" }]}>
                                <Input className="form-control" />
                              </Form.Item>
                            </Col>

                            <Col span={12}>
                              <Form.Item label="Nombre de cylindres" name="cylinders">
                                <Input className="form-control" defaultValue={1} />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>

                        <Col span={8}>
                          <Form.Item
                            label="Type de véhicule"
                            name="vehicule"
                            rules={[{ required: true, message: "Champs requis" }]} >
                            <Select loading={isLoading}>
                              {vehicules?.map((item) => (<Option value={item.code}>{item.libelle}</Option>))}
                            </Select>
                          </Form.Item>

                          <Row gutter={24}>
                            <Col span={12}>
                              <Form.Item
                                label="Capital (optionnel)"
                                name="capital">
                                <InputNumber className="form-control" min={1} defaultValue={1} style={{ width: '-webkit-fill-available' }} />
                              </Form.Item>
                            </Col>

                            <Col span={12}>
                              <Form.Item
                                label="Durée"
                                name="duration">
                                <InputNumber className="form-control" min={1} defaultValue={1} style={{ width: '-webkit-fill-available' }} />
                              </Form.Item>
                            </Col>
                          </Row>

                          <Row gutter={24}>
                            <Col span={12}>
                              <Form.Item
                                label="Montant accessoires"
                                name="accessory_amount">
                                <Input className="form-control" defaultValue={1000} />
                              </Form.Item>
                            </Col>

                            <Col span={12}>
                              <Form.Item label="Puissance" name="tax_power" rules={[{ required: true, message: "Champs requis" }]}>
                                <Input className="form-control" />
                              </Form.Item>
                            </Col>
                          </Row>

                          <Form.Item
                            label="Periodicité"
                            name="periodicity"
                            rules={[{ required: true, message: "Champs requis" }]}>
                            <Select>
                              <Option value="JOUR">JOUR</Option>
                              <Option value="MOIS">MOIS</Option>
                            </Select>
                          </Form.Item>
                        </Col>


                        <Col span={8}>
                          <Form.Item
                            label="Option de couverture"
                            name="couverture"
                            rules={[{ required: true, message: "Champs requis" }]} >
                            <Select loading={isLoading}>
                              {couvertures?.map((item) => (<Option value={item.code}>{item.libelle}</Option>))}
                            </Select>
                          </Form.Item>

                          <Form.Item
                            label="Pack privilege"
                            name="pack_privileges"
                            rules={[{ required: true, message: "Champs requis" }]} >
                            <Select loading={isLoading}>
                              {packsPrivileges?.map((item) => (<Option value={item.code}>{item.libelle}</Option>))}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span />
                        <Button type="primary" htmlType="submit" className="btn btn-secondary">
                          Continuer
                        </Button>
                      </div>
                    </Form>
                    {error &&
                      <div>
                        <br />
                        <Alert
                          message={JSON.stringify(error)}
                          type="error"
                          className="alert-error"
                          showIcon
                        />
                      </div>
                    }
                  </div>
                )}

                {activeTab === 'validation' && (
                  <div className="tab-content-validation">
                    <div className="table">
                      <table>
                        <thead>
                          <th>Garantie</th>
                          <th>Prime Annuelle</th>
                          <th>Prime Periodique</th>
                          <th>CEDEAO</th>
                        </thead>

                        <tbody>
                          <tr>
                            <td>Responsabilité Civile</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                          </tr>

                          <tr>
                            <td>Responsabilité Civile</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <br />
                    <hr />

                    <div className="total">
                      <Row>
                        <Col lg={12}>
                          <h3>Prime nette: <span>{simulatorResult?.total_net_prime}F</span></h3>
                          <h3>Accessoires: <span>{simulatorRequest?.accessory_amount}F</span></h3>
                          <h3>Commissions: <span>{simulatorResult?.total_commissions}F</span></h3>
                          <h3>Prime TTC: <span>{simulatorResult?.total_taxs}F</span></h3>
                        </Col>
                        <Col lg={12}>
                          <h3>CEDEAO/Frais: <span>{simulatorResult?.total_costs}F</span></h3>
                          <h3>Montant FGA: <span>{simulatorResult?.total_fga}F</span></h3>
                          <h3>Montant Taxes: <span>{simulatorResult?.total_amount}F</span></h3>
                        </Col>
                      </Row>
                    </div>
                    <hr />
                    <br />
                    <div className="form">
                      <Form
                        name="basic"
                        form={form}
                        layout="vertical"
                        onFinish={handleFees}
                      >
                        <Row gutter={24}>
                          <Col lg={8}>
                            <Form.Item
                              label="Nom de l'assuré"
                              name="first_name">
                              <Input className="form-control" />
                            </Form.Item>

                            <Form.Item
                              label="Adresse"
                              name="address">
                              <Input className="form-control" />
                            </Form.Item>

                            <Form.Item
                              label="Imatriculation"
                              name="registration">
                              <Input className="form-control" />
                            </Form.Item>
                          </Col>

                          <Col lg={8}>
                            <Form.Item
                              label="Prénom de l'assuré"
                              name="last_name">
                              <Input className="form-control" />
                            </Form.Item>

                            <Form.Item
                              label="Téléphone"
                              name="cellular">
                              <Input className="form-control" />
                            </Form.Item>

                            <Form.Item
                              label="Numero de chassis"
                              name="chassis">
                              <Input className="form-control" />
                            </Form.Item>
                          </Col>


                          <Col lg={8}>
                            <Form.Item
                              label="Profession"
                              name="profession">
                              <Input className="form-control" />
                            </Form.Item>

                            <Form.Item
                              label="Adresse email"
                              name="email">
                              <Input className="form-control" />
                            </Form.Item>

                            <Form.Item
                              label="Marque"
                              name="brand">
                              <Input className="form-control" />
                            </Form.Item>
                          </Col>

                        </Row>

                        <Row gutter={24}>
                          <Col lg={6}>
                            <Form.Item
                              label="Date de mise en circulation"
                              name="date_of_circulation"
                              style={{ width: "100%" }}>
                              <DatePicker
                                placeholder="Date de mise en circulation"
                                className="form-control"
                                style={{ width: "100%" }}
                                onChange={(date, dateString) => {
                                  setDateOfCirculation(dateString)
                                }} />
                            </Form.Item>
                          </Col>
                          <Col lg={6}>
                            <Form.Item
                              label="Date d'effet"
                              name="effective_date"
                              style={{ width: "100%" }}>
                              <DatePicker
                                placeholder="Date d'effet"
                                className="form-control"
                                style={{ width: "100%" }}
                                onChange={(date, dateString) => {
                                  console.log(date, dateString);
                                  setEffectiveDate(dateString)
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col lg={6}>
                            <Form.Item
                              label="Statut légal"
                              name="legal_status"
                              rules={[{ required: true, message: "Champs requis" }]}>
                              <Select>
                                <Option value="PHYSIQUE">PHYSIQUE</Option>
                                <Option value="MORALE">MORALE</Option>
                                <Option value="ASSUREUR">ASSUREUR</Option>
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row gutter={24}>
                          <Col lg={6}>
                            <Form.Item
                              label="Usage du vehicule"
                              name="usage"
                              rules={[{ required: true, message: "Champs requis" }]}>
                              <Select>
                                <Option value="C">Commercial</Option>
                                <Option value="N">Non commercial</Option>
                              </Select>
                            </Form.Item>
                          </Col>

                          <Col lg={6}>
                            <Form.Item
                              label="Model du vehicule"
                              name="model">
                              <Input className="form-control" />
                            </Form.Item>
                          </Col>
                        </Row>

                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span />
                          <Button type="primary" htmlType="submit" className="btn btn-secondary" loading={isLoading}>
                            Confirmer
                          </Button>
                        </div>
                      </Form>
                      {error &&
                        <div>
                          <br />
                          <Alert
                            message={JSON.stringify(error)}
                            type="error"
                            className="alert-error"
                            showIcon
                          />
                        </div>
                      }
                    </div>

                  </div>
                )}
              </div>
            </Card>
          </Col>
        </Row>
      </Spin>
    </div>
  );
}
export default BillSaarPage;
